import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { Observable } from 'rxjs';
import { Admin } from '../../core/models/admin.model';
import { AdminService } from '../../core/services/admin.service';
import { AuthService } from '../../core/services/login.service';
import { Client } from '../../core/models/client.model';
import { ClientService } from '../../core/services/client.service';
import { Application, ProfileConfig, SelfService, SelfServiceComponent } from 'sigesr-self-service-lib';
import { Router } from '@angular/router';
import Keycloak from 'keycloak-js';
import { environment } from '../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    SelfServiceComponent
],
  template: `

    <div class="header-mobile">
      <div class="header-mobile-left df-center-8">
        <button class="show-menu-dash" id="trigger" (click)="onShowMobileMenu()">
          <img src="assets/images/menu.svg" alt="">
        </button>
        <svg width="1" height="36" viewBox="0 0 1 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="1" height="36" fill="#E1E1E1"/>
        </svg>
        <strong class="df-center-8">
          <img src="assets/images/logo.svg" alt="" class="logo-mobile">
          <span>Habilitation</span>
        </strong>
      </div>
      <div class="header-mobile-right">
        <self-service [user]="currentUser"
                      [config]="profileConfig" 
                      (onPasswordChanged)="handlePasswordChanged()"
                      (onLogout)="handleLogout()" 
                      (onAppSelected)="handleAppSelected($event)"
                      (onShowAllApps)="handleShowAllApps()" >
        </self-service>
      </div>
    </div>
    <div class="dash-header">
      <div class="dash-header-container">
        <h4 class="dash-header-title">Habilitation</h4>
        <self-service [user]="currentUser" 
                      [config]="profileConfig" 
                      (onPasswordChanged)="handlePasswordChanged()"
                      (onLogout)="handleLogout()" 
                      (onAppSelected)="handleAppSelected($event)"
                      (onShowAllApps)="handleShowAllApps()" >
        </self-service>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    .dash-header {
      background-color: #FFFFFF;
      padding: 24px 24px;
    }
    .dash-header-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .dash-header-title {
      margin: 0;
      font-size: 171.4285714286%;
      font-weight: 700;
    }
    .dash-header-session > ul {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      list-style: none;
      gap: 36px;
      margin: 0;
    }
    .dash-header-session > ul li {
      font-weight: 700;
    }
    .dash-header-session-user {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 8px;
    }
    .dash-header-session-user button {
      border: none;
      background-color: transparent;
      cursor: pointer;
    }
    .dash-header-session-user .avatar {
      height: 36px;
      width: 36px;
      object-fit: cover;
      border-radius: 36px;
    }

    .header-mobile {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      background: #FFFFFF;
    }
    .header-mobile ul {
      list-style: none;
      margin: 0;
      padding: 0;
    }
    .header-mobile .logo-mobile {
      height: 48px;
      object-fit: contain;
      padding-left: 5px;
    }

    .applications-list {
      color: #379159;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
      cursor: pointer;
    }

    .dropdown-list, .dropdown-list-user {
      position: absolute;
      top: 80px;
      min-width: 250px;
    }
    .dropdown-list span, .dropdown-list-user span {
      display: unset !important;
    }
    .dropdown-list ul, .dropdown-list-user ul {
      background-color: #FFFFFF;
      border-radius: 12px;
      padding: 16px;
      flex-direction: column;
      gap: 12px;
      border: 1px solid #E1E2E2;
      align-items: unset;
    }
    .dropdown-list ul li, .dropdown-list-user ul li {
      display: block;
    }
    .dropdown-list ul li a, .dropdown-list-user ul li a {
      display: block;
      padding: 10px 0;
      color: #263435;
      font-weight: 500;
      text-decoration: none;
      text-align: right;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 8px;
    }
    .dropdown-list ul li a:hover, .dropdown-list-user ul li a:hover {
      color: #45B56F;
    }

    .app-list-grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      width: 320px;
      list-style: none;
      position: absolute;
      z-index: 200;
      top: 40px;
      right: 0;
      padding-left: 0;
      background-color: #FFFFFF;
      border: 1px solid #E1E2E2;
      border-radius: 12px;
      text-align: center;
    }
    .app-list-grid li a {
      color: #263435;
      text-decoration: none;
      padding: 16px;
      display: inline-block;
    }
    .app-list-grid li a:hover {
      color: #45B56F;
    }
    .app-list-grid li a span {
      display: block !important;
    }
    .app-list-grid li a img {
      height: 48px;
      object-fit: contain;
    }

    @media screen and (max-width: 600px) {
      .header-mobile-right span {
        display: none;
      }
      .app-list-grid {
        grid-template-columns: 1fr 1fr;
        right: -104px;
      }
    }
    @media screen and (min-width: 1024px) {
      .header-mobile {
        display: none;
      }
    }
    @media screen and (max-width: 1023px) {
      .dash-header {
        display: none;
      }
      .show-menu-dash {
        border: none;
        background-color: transparent;
      }
    }
  `]
})
export class HeaderComponent implements OnInit {

  @Output() toggleSidebar = new EventEmitter<void>();
  clientId = 'sca';

  currentAdmin$: Observable<Admin> | undefined;
  clients: Client[] = [];
  selectedClientId: string | null = null;
  isBrowser: boolean = false;
  currentUserId: string | null = null;
  isLoadingClients: boolean = false;
  isLoadingApplications: boolean = false;

  currentUser: any;
  currentApp: Application | null = null;
  profileConfig: ProfileConfig = {
    showProfil: true,
    showChangePassword: true,
    avatarBackgroundColor: "#45B56F",
    showLogout: true,
    showAppSelector: true,
    maxVisibleApps: 9,
    appBuilder: {
      currentApp: 'sca',        // App courante (sera exclue)
      environment: environment.env as 'dev' | 'prod' | 'staging' | 'uat',
      // apps non défini = toutes les apps sauf 'sca'
    }
  };
  private isMobileMenuOpen: boolean | undefined;

  constructor(
    private adminService: AdminService,
    private clientService: ClientService,
    private authService: AuthService,
    private selfService: SelfService,
    private router: Router,
    private keycloack: Keycloak,
    private dialog: MatDialog
  ) {
    this.isMobileMenuOpen = false
  }

  ngOnInit(): void {
    this.currentAdmin$ = this.adminService.getCurrentAdmin(this.clientId);

    if (this.keycloack.authenticated) {
      this.keycloack.loadUserInfo().then((userProfile: any) => {
        this.currentUser = {
          username: userProfile.preferred_username,
          email: userProfile.email,
          // firstname: userProfile.firstName,
          // lastname: userProfile.lastName,
          fullname: userProfile.name
        };
        this.selfService.setUserProfile(this.currentUser);
      }).catch(error => {
        console.error('Erreur lors du chargement du profil:', error);
      });
    } else {
      // Si pas authentifié, initialiser avec des valeurs par défaut
      this.currentUser = {
        username: 'Invité',
        email: '',
        firstname: 'Utilisateur',
        lastname: 'Anonyme',
      };
      this.selfService.setUserProfile(this.currentUser);
    }

    // Gestion du localStorage (côté navigateur)
    if (this.isBrowser) {
      this.currentUserId = localStorage.getItem('userId');
      // console.log('ID utilisateur connecté:', this.currentUserId);

      if (this.currentUserId) {
        this.loadUserClients(this.currentUserId);
        this.loadApplications();
      } else {
        // console.error('Aucun utilisateur connecté trouvé');
        this.authService.logout();
      }
    }
  }

  onSelfServiceMenuItemClick(itemId: string): void {
    // console.log('Menu item cliqué :', itemId);

    if (itemId === 'change-password') {
      this.handleChangePassword();
    }
  }

  private loadApplications(): void {
    this.isLoadingApplications = true;
  }

  private loadUserClients(userId: string): void {
    this.isLoadingClients = true;

    this.clientService.getClientsByUser(userId).subscribe({
      next: (clients: any) => {
        if (Array.isArray(clients)) {
          this.clients = clients;
        } else {
          this.clients = Object.entries(clients as any).map(([id, clientId]: [string, any]) => ({
            id: id,
            clientId: clientId as string,
            name: clientId as string
          }));
        }

        if (this.clients.length > 0) {
          this.selectedClientId = this.clients[0].id;
          this.clientService.setActiveClient(this.selectedClientId);
        }

        this.isLoadingClients = false;
      },
      error: (error: any) => {
        console.error('Erreur lors de la récupération des clients:', error);
        this.clients = [];
        this.isLoadingClients = false;
      }
    });
  }

  logout(): void {
    const confirmLogout = confirm('Êtes-vous sûr de vouloir vous déconnecter ?');

    if (confirmLogout) {
      this.currentAdmin$?.subscribe({
        next: (admin: Admin) => {
          const username = admin?.username || 'utilisateur';
          // console.log('👤 Username récupéré:', username);
          this.authService.logoutKeycloak(username);
        },
        error: (error: any) => {
          // console.error('Erreur récupération admin:', error);
          this.authService.logoutKeycloak('utilisateur');
        }
      });
    }
  }

  handleChangePassword(): void {

    // import('../../features/change-password-dialog/change-password-dialog.component').then(m => {
    //   const ref = this.dialog.open(m.ChangePasswordDialogComponent, {
    //     panelClass: 'transparent-dialog',
    //     maxWidth: '110vw',
    //     maxHeight: '100vh',
    //     width: '110vw',
    //     height: '100vh',
    //     hasBackdrop: false,
    //     autoFocus: true,
    //     disableClose: true,
    //     data: { username: this.currentUser?.username || '' }
    //   });

    //   // Déconnexion automatique après succès
    //   ref.afterClosed().subscribe(result => {
    //     if (result?.success) {
    //       this.handleLogout();
    //     }
    //   });
    // });

    // this.selfServiceFacade
    // .openChangePasswordDialog(this.currentUser?.username || '')
    // .then(result => {
    //   if (result?.success) {
    //     this.handleLogout();
    //   }
    // });
  }

  /**
 * Déclenché après un changement de mot de passe réussi.
 *
 *    Le backend a DÉJÀ invalidé toutes les sessions Keycloak
 *    (`POST /users/{id}/logout`). L'access token local reste
 *    techniquement valide jusqu'à son expiration (5 min), mais
 *    le refresh token est mort → toute tentative de refresh échouera.
 *
 * On force donc une déconnexion immédiate pour éviter les 401 en cascade.
 */
  handlePasswordChanged(): void {
    console.log('[Header] Mot de passe changé — déconnexion forcée');

    // Petit délai pour laisser le dialog se fermer proprement
    setTimeout(() => this.performLogout(), 150);
  }

  /**
   * Effectue un logout Keycloak, avec fallback manuel si la session
   * est déjà invalide côté serveur (cas courant ici).
   */
  private performLogout(): void {
    try {
      // Keycloak logout : nettoie les tokens locaux et redirige
      this.keycloack.logout({
        redirectUri: window.location.origin,   // page d'accueil du SPA
        logoutMethod: 'GET',
      });
    } catch (error) {
      // Si Keycloak refuse (session déjà morte côté serveur),
      // on fait un nettoyage manuel + redirection vers le login
      console.warn('[Header] Keycloak logout échoué, fallback manuel:', error);
      this.manualLogoutFallback();
    }
  }

  /**
   * Fallback : nettoie tout et redirige vers la page de login Keycloak.
   */
  private manualLogoutFallback(): void {
    // 1. Nettoyer le storage local
    localStorage.clear();
    sessionStorage.clear();

    // 2. Construire l'URL de logout Keycloak
    const kcConfig = environment.keycloakConfig as any;
    const baseUrl = kcConfig.url?.replace(/\/$/, '') || '';
    const realm = kcConfig.realm || '';

    if (baseUrl && realm) {
      const logoutUrl =
        `${baseUrl}/realms/${realm}/protocol/openid-connect/logout` +
        `?post_logout_redirect_uri=${encodeURIComponent(window.location.origin)}` +
        `&client_id=${encodeURIComponent(kcConfig.clientId || '')}`;

      window.location.href = logoutUrl;
    } else {
      // Ultime fallback : recharger l'app (le SPA déclenchera le check-sso)
      window.location.href = '/';
    }
  }

  handleLogout(): void {
    // this.keycloack.logout({
    //   redirectUri: window.location.href,
    //   logoutMethod: 'GET',
    // });
    // localStorage.clear();
    console.log('[Header] Déconnexion manuelle');
    this.performLogout();
  }

  handleAppSelected(app: Application): void {
    // console.log('Application sélectionnée:', app);
    this.currentApp = app;
    this.selfService.setCurrentApp(app);
    this.profileConfig.currentAppId = app.id;

    if (app.url) {
      this.router.navigate([app.url]);
    }
  }

  handleShowAllApps() { }

  onShowMobileMenu() {
    this.toggleSidebar.emit();
  }
}
